// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vNCS","content":"styles_content__3ah2J","tableWrap":"styles_tableWrap__1Douq"};